/**
 * HTTP Client Response Error
 */
export default class HttpClientResponseError extends Error {
    constructor(message) {
        super(message);
        this.name = "HttpClientResponseError";
    }
}
